import React from "react";

export const DaysHeader = () => {
  return (
    <div className="grid grid-cols-7 gap-px border-b border-slate-200 dark:border-slate-700">
      {["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"].map((day) => {
        return (
          <div className="px-1 py-3" key={day}>
            <div className="text-center text-sm font-medium text-slate-500 lg:hidden">{day.substring(0, 3)}</div>
            <div className="hidden text-center text-sm font-medium text-slate-500 lg:block dark:text-slate-400">
              {day}
            </div>
          </div>
        );
      })}
    </div>
  );
};
